<template>

  <!--生成分享海报-->
  <div class="alert-box poster-alert-new">
    <div class="alert-con">
      <p class="mask" @click="closeFun()"></p>
      <p class="poster-img">
        <img class="poster-alert-close" @click="closeFun()" src="../assets/red-envelopes-close.png" alt="">
        <img class="poster-alert-img" :src="postImg" alt="">
      </p>
      <!--640*960-->
      <p class="poster-btn">长按图片保存或发送给朋友</p>
    </div>
  </div>

</template>

<script>

  import {getShopPoster,getSpotPoster,getGuidePoster} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import {routeUrl} from '@/utils/wechat'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {},
        TimeStamp: new Date().getTime(),  //获取当前时间
        postImg: '',
      }
    },
    created(){

      this.initData();
    },
    props: ['type','id'],
    computed: {

    },
    methods: {

       initData(){
          this.$loading.show('海报生成中');
          this.userInfo = getStore("userInfo");
          if(this.type == 'extend'){
            this.postImg = routeUrl + 'authChannel/getQRcode.do?id=' + this.id +'&type=1';
          }else if(this.type == 'shop'){
            this.postImg = routeUrl + 'sharePort/shop.do?shopId=' + this.id +'&type=1&openId=' + this.userInfo.openid;
          }else if(this.type == 'spot'){
            this.postImg = routeUrl + 'sharePort/spot.do?spotId=' + this.id +'&type=1&openId=' + this.userInfo.openid;
          }else if(this.type == 'guide'){
            this.postImg = routeUrl + 'sharePort/voiceBag.do?bagId=' + this.id +'&type=1&openId=' + this.userInfo.openid;
          }

         var self = this
         setTimeout(function(){
           self.$loading.hide();
         },800)

      },

      //关闭弹窗
      closeFun(){
        this.$emit('close', 0);
      },

    },
  }
</script>

<style scoped>

  @import '../style/alert';



</style>



// WEBPACK FOOTER //
// src/components/AlertPoster.vue